import { render, staticRenderFns } from "./realwater.vue?vue&type=template&id=716a8291&scoped=true&"
import script from "./realwater.vue?vue&type=script&lang=js&"
export * from "./realwater.vue?vue&type=script&lang=js&"
import style0 from "./realwater.vue?vue&type=style&index=0&id=716a8291&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716a8291",
  null
  
)

export default component.exports